"use client";

import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";

export const MigrationSection = () => {
  return (
    <section className="section-spacing overflow-hidden relative">

      <div className="section-container relative z-10">
        <motion.div
          className="max-w-4xl mx-auto space-y-8 text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <h2 className="text-3xl md:text-5xl font-display font-medium leading-tight">
            Already tried to install it? <span className="gradient-text">We've seen that too.</span>
          </h2>

          <ul className="text-left max-w-2xl mx-auto space-y-4 text-muted-foreground">
            {[
              "Upgrade left gateway and old services fighting over ports; dashboard never came up cleanly.",
              "Gateway runs, dashboard opens, but every message gets blank replies or no response.",
              "Re-running install/doctor repeatedly, still stuck in the same state.",
            ].map((item, i) => (
              <motion.li
                key={i}
                className="flex items-start gap-3 text-sm leading-relaxed"
                initial={{ opacity: 0, x: -15 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.2 + i * 0.1 }}
              >
                <span className="h-1.5 w-1.5 rounded-full bg-[hsl(var(--coral-bright))] mt-2 shrink-0" />
                {item}
              </motion.li>
            ))}
          </ul>

          <p className="text-foreground/80 max-w-2xl mx-auto">
            We come in, map what's running, shut down the broken bits, then rebuild a clean Clawbiz setup with docs so you're not scared to touch it again.
          </p>

          <Button size="lg" variant="ghost" className="text-primary hover:bg-[hsl(var(--coral-bright)/0.08)] hover:text-primary" asChild>
            <a href="#contact">I need a rescue install →</a>
          </Button>
        </motion.div>
      </div>
    </section>
  );
};
